import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import apiClient from '../services/api';

export const useLogin = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (credentials) => apiClient.login(credentials),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
      navigate('/dashboard');
    },
  });
};

export const useRegister = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userData) => apiClient.register(userData),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
      navigate('/dashboard');
    },
  });
};

export const useLogout = () => {
  const queryClient = useQueryClient();

  return () => {
    apiClient.logout();
    queryClient.clear();
  };
};

export const useUser = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: () => apiClient.getProfile(),
    enabled: !!localStorage.getItem('access_token'),
  });
};

export const useAuth = () => {
  const { data: user, isLoading } = useUser();
  const guestMode = localStorage.getItem('guestMode') === 'true';
  
  return {
    user,
    isLoading,
    isAuthenticated: !!user || guestMode,
    isGuest: guestMode && !user,
  };
};